import { useEffect } from 'react';

export function VideoPreloader() {
  useEffect(() => {
    const probe = document.createElement('video');
    if (!probe.canPlayType('video/webm; codecs="vp9"')) {
      // eslint-disable-next-line no-console
      console.warn('[VideoPreloader] Browser may not fully support VP9 WebM playback.');
    }
  }, []);

  return (
    <div style={{ display: 'none' }}>
      <link rel="preload" as="video" href="/video/gator_passive.webm" />
      <link rel="preload" as="video" href="/video/gator_talking.webm" />
    </div>
  );
}
